import Handler from "@/core/domain/usecase/handler";

const fetchReleaseConfirmationRepository = (axios) => async (pagination) => {
    try {
        const response = await axios.get('/release-confirmation', {
            params: pagination
        });

        const releaseConfirmationPagination = response.data;
        return releaseConfirmationPagination;
    } catch (err) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err);
        } else {
            throw err;
        }
    }
}

export default fetchReleaseConfirmationRepository